import { r as registerInstance, h, H as Host } from './index-1755b6c5.js';

const ProactiveCaseClosureModal = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.successMessageWasShown = false;
        this.handleClose = () => {
            this.modal.triggerClose();
        };
        this.handleModalClose = () => {
            if (this.successMessageWasShown) {
                window.location.reload();
            }
        };
        this.callId = undefined;
        this.locale = undefined;
        this.modalName = undefined;
        this.env = "prod";
        this.legacyApi = false;
        this.debug = false;
    }
    render() {
        return (h(Host, { key: '48efb12a31d53adea24abfd5da7735c3bdf50aaf' }, h("ux-modal", { key: '1e5f1d0ca94d5ed0e23365657db1a09f8171f5f5', onUxModalClose: () => this.handleModalClose(), name: this.modalName, ref: (el) => (this.modal = el) }, h("ux-modal-content", { key: '295c804e05a61c2e0426663e06f6dfbf1f637b85' }, h("mf-proactive-case-closure", { key: '4c226b59bc7d1a701ec618f947a6675dcb269107', callId: this.callId, locale: this.locale, onMfServiceCallCancel: () => this.handleClose(), onMfServiceCallSuccess: () => {
                this.handleClose();
                window.location.reload();
            }, onMfServiceCallShowSuccess: () => (this.successMessageWasShown = true), env: this.env, legacyApi: this.legacyApi, debug: this.debug })))));
    }
};

export { ProactiveCaseClosureModal as mf_proactive_case_closure_modal };

//# sourceMappingURL=mf-proactive-case-closure-modal.entry.js.map